/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Calendar from './Calendar/index'
import Comms from './Comms/index'
import EmployeeWorkHours from './EmployeeWorkHours/index'
import Financial from './Financial/index'
import Kpis from './Kpis/index'
import Marketing from './Marketing/index'
import No from './No/index'
import Notes from './Notes/index'
import Orders from './Orders/index'
import Patients from './Patients/index'
import PatientsList from './PatientsList/index'
import Profile from './Profile/index'
import React from 'react'
import RedirectToActiveTab from './RedirectToActiveTab/index'
import RedirectToDefaultTab from './RedirectToDefaultTab/index'
import Reports from './Reports/index'
import SentryErrorBoundary from 'DesignSystem/SentryErrorBoundary/react'
import Settings from './Settings/index'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import Tasks from './Tasks/index'
import WorkHours from './WorkHours/index'
import Workflows from './Workflows/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  return (<React.Fragment
>
<SentryErrorBoundary
  viewPath={`${viewPath}/SentryErrorBoundary`}
>
{childProps => (
<SuspenseBoundary
{...childProps}
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={flowValue === 'No'}>
<No
{...childProps}
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'RedirectToActiveTab'}>
<RedirectToActiveTab
{...childProps}
  viewPath={`${viewPath}/RedirectToActiveTab`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'RedirectToDefaultTab'}>
<RedirectToDefaultTab
{...childProps}
  viewPath={`${viewPath}/RedirectToDefaultTab`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Comms'}>
<Comms
{...childProps}
  viewPath={`${viewPath}/Comms`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Settings'}>
<Settings
{...childProps}
  viewPath={`${viewPath}/Settings`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Kpis'}>
<Kpis
{...childProps}
  viewPath={`${viewPath}/Kpis`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Reports'}>
<Reports
{...childProps}
  viewPath={`${viewPath}/Reports`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Workflows'}>
<Workflows
{...childProps}
  viewPath={`${viewPath}/Workflows`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Patients'}>
<Patients
{...childProps}
  viewPath={`${viewPath}/Patients`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PatientsList'}>
<PatientsList
{...childProps}
  viewPath={`${viewPath}/PatientsList`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Orders'}>
<Orders
{...childProps}
  viewPath={`${viewPath}/Orders`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'WorkHours'}>
<WorkHours
{...childProps}
  viewPath={`${viewPath}/WorkHours`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'EmployeeWorkHours'}>
<EmployeeWorkHours
{...childProps}
  viewPath={`${viewPath}/EmployeeWorkHours`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Calendar'}>
<Calendar
{...childProps}
  viewPath={`${viewPath}/Calendar`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Notes'}>
<Notes
{...childProps}
  viewPath={`${viewPath}/Notes`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Tasks'}>
<Tasks
{...childProps}
  viewPath={`${viewPath}/Tasks`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Financial'}>
<Financial
{...childProps}
  viewPath={`${viewPath}/Financial`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Marketing'}>
<Marketing
{...childProps}
  viewPath={`${viewPath}/Marketing`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Profile'}>
<Profile
{...childProps}
  viewPath={`${viewPath}/Profile`}
/>
</fromFlow.When>
</React.Fragment>
)}
</SuspenseBoundary>
)}
</SentryErrorBoundary>
{children}
</React.Fragment>)
}